var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as go from '../../../../libs/gojs/release/go';
import { NodeElement } from './base/node-element';
import { DiagramConsts } from '../diagram-consts';
import { GraphService } from '../../../../shared/gallery/graph.service';
var WeatherElement = /** @class */ (function (_super) {
    __extends(WeatherElement, _super);
    function WeatherElement(injector) {
        var _this = _super.call(this, injector) || this;
        _this.graphService = injector.get(GraphService);
        return _this;
    }
    WeatherElement.prototype.compile = function (model, data, svg) {
        svg.empty();
        model['version'] = 4;
        model['size'] = this.sizeService.parse(data.size);
        model['stroke'] = data.stroke;
        model['fill'] = data.fill;
    };
    WeatherElement.prototype.getPaletteTemplate = function () {
        var $ = go.GraphObject.make;
        return $(go.Node, 'Vertical', { width: 50, height: 90, locationSpot: go.Spot.Center }, $(go.Picture, {
            margin: 10,
            source: '/assets/common/images/configure/elements/weather-small.png'
        }), $(go.TextBlock, {
            alignment: go.Spot.Center,
            text: this.l(this.getCategoryKey()),
            editable: false
        }));
    };
    WeatherElement.prototype.getDiagramTemplate = function () {
        var _this = this;
        var $ = go.GraphObject.make;
        return $(go.Node, 'Vertical', {
            locationSpot: go.Spot.TopLeft,
            selectionAdornmentTemplate: $(go.Adornment, 'Spot', $(go.Panel, go.Panel.Auto, $(go.Shape, { fill: null, stroke: 'dodgerblue', strokeWidth: 1 }, new go.Binding('stroke', 'locked', function (locked) { return locked ? '#f65177' : 'dodgerblue'; })), $(go.Placeholder)))
        }, new go.Binding('angle').makeTwoWay(), new go.Binding('movable', 'locked', function (locked) { return !locked; }), new go.Binding('resizable', 'locked', function (locked) { return !locked; }), new go.Binding('deletable', 'locked', function (locked) { return !locked; }), new go.Binding('location', 'loc', go.Point.parse).makeTwoWay(go.Point.stringify), new go.Binding('zOrder'), 
        // can be resided according to the user's desires
        $(go.Panel, 'Spot', $(go.Picture, {
            alignment: new go.Spot(0, 0)
        }, new go.Binding('source', 'fill', function (fill) { return _this.getRectSvg(fill); })), $(go.TextBlock, {
            text: '28',
            font: '53px "Microsoft YaHei Light"',
            alignment: new go.Spot(0.15, 0.39)
        }, new go.Binding('stroke')), $(go.TextBlock, {
            text: '°C',
            font: '1em sans-serif',
            alignment: new go.Spot(0.3, 0.2, -6, -2)
        }, new go.Binding('stroke')), $(go.TextBlock, {
            text: '/',
            font: '20px sans-serif',
            alignment: new go.Spot(0.32, 0.46, -6, 0)
        }, new go.Binding('stroke')), $(go.Picture, {
            alignment: new go.Spot(0.36, 0.48, -6, 0),
        }, new go.Binding('source', 'stroke', function (stroke) { return _this.getRainSvg(stroke); })), $(go.TextBlock, {
            text: '60%',
            font: '14px sans-serif',
            alignment: new go.Spot(0.45, 0.5, -6, 0)
        }, new go.Binding('stroke')), $(go.Picture, {
            alignment: new go.Spot(0.07, 0.85, 0, -1)
        }, new go.Binding('source', 'stroke', function (stroke) { return _this.getLocSvg(stroke); })), $(go.TextBlock, {
            text: '上海',
            font: '12px sans-serif',
            alignment: new go.Spot(0.13, 0.85, 4, 0)
        }, new go.Binding('stroke')), $(go.Picture, {
            name: 'Sunny',
            width: 120,
            height: 66,
            source: '/assets/common/images/configure/elements/weather-type/cloudy.png',
            alignment: new go.Spot(1, 0, -67, 35)
        }), $(go.Picture, {
            alignment: new go.Spot(0.25, 0.85)
        }, new go.Binding('source', 'stroke', function (stroke) { return _this.getWindSvg(stroke); })), $(go.TextBlock, {
            text: '东风1~3级',
            font: '12px sans-serif',
            textAlign: 'left',
            alignment: new go.Spot(0.4, 0.85)
        }, new go.Binding('stroke')), $(go.TextBlock, {
            text: '多云',
            font: '12px sans-serif',
            textAlign: 'center',
            alignment: new go.Spot(1, 0.85, -66, 0)
        }, new go.Binding('stroke'))));
    };
    WeatherElement.prototype.getCategoryKey = function () {
        return DiagramConsts.elements.weatherKey;
    };
    WeatherElement.prototype.createIconSvg = function (stroke, viewBox, width, height) {
        if (viewBox === void 0) { viewBox = '0 0 156 200'; }
        if (width === void 0) { width = '11'; }
        if (height === void 0) { height = '11'; }
        var iconSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        iconSvg.setAttribute('x', '0');
        iconSvg.setAttribute('y', '0');
        iconSvg.setAttribute('width', width);
        iconSvg.setAttribute('height', height);
        iconSvg.setAttribute('viewBox', viewBox);
        iconSvg.setAttribute('fill', stroke);
        return iconSvg;
    };
    WeatherElement.prototype.createRectSvg = function (fill, width, height) {
        var iconSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        iconSvg.setAttribute('x', '0');
        iconSvg.setAttribute('y', '0');
        iconSvg.setAttribute('width', width);
        iconSvg.setAttribute('height', height);
        return iconSvg;
    };
    WeatherElement.prototype.convertSvgToDataUri = function (element) {
        var svgXml = new XMLSerializer().serializeToString(element);
        return "data:image/svg+xml;base64," + window.btoa(svgXml);
    };
    WeatherElement.prototype.getRectSvg = function (fill) {
        var rectSvg = this.createRectSvg(fill, '268', '92');
        rectSvg.innerHTML = "<g><rect width=\"268\" height=\"92\" rx=\"2\" fill=\"" + fill + "\" /></g>";
        return this.convertSvgToDataUri(rectSvg);
    };
    WeatherElement.prototype.getRainSvg = function (stroke) {
        var rainSvg = this.createIconSvg(stroke);
        rainSvg.innerHTML = "\n<g>\n<path class=\"st0\" d=\"M78,200c-43,0-78-33.3-78-74.3C0,74.9,55.5,20.4,72.5,4.9L77.8,0l5.4,4.8c0.7,0.6,72.5,64.6,72.8,120.9\nC156,166.7,121,200,78,200z M77.9,21.7C60.2,38.8,16,85.4,16,125.7c0,32.2,27.8,58.3,62,58.3s62-26.2,62-58.3\nC139.7,88.4,99.2,41.9,77.9,21.7z\"/>\n<path class=\"st0\" d=\"M87.7,163.9c-4.2,0-7.6-3.3-7.7-7.5c0-4.2,3.3-7.7,7.6-7.7c14.3-0.2,25.7-11.3,25.5-24.7\nc0-4.2,3.3-7.7,7.6-7.7c0,0,0.1,0,0.1,0c4.2,0,7.6,3.3,7.7,7.5C128.7,145.6,110.5,163.6,87.7,163.9\nC87.7,163.9,87.7,163.9,87.7,163.9z\"/>\n</g>";
        return this.convertSvgToDataUri(rainSvg);
    };
    WeatherElement.prototype.getLocSvg = function (stroke) {
        var locSvg = this.createIconSvg(stroke);
        locSvg.innerHTML = "<g>\n<path class=\"st0\" d=\"M78,0C35,0,0,33.3,0,74.3c0,50.8,55.5,105.4,72.6,120.9l5.3,4.8l5.3-4.7c0.7-0.6,72.5-64.6,72.8-121v0\nC156,33.3,121,0,78,0z M78,178.6c-17.8-17.1-62.1-63.9-62.1-104.4C15.8,42,43.7,15.7,78,15.7c34.3,0,62.2,26.3,62.2,58.5\nC140,111.8,99.2,158.4,78,178.6z\"/>\n<path class=\"st0\" d=\"M78,40.4c-17.8,0-32.4,14.4-32.4,32.2s14.5,32.2,32.4,32.2s32.4-14.4,32.4-32.2S95.8,40.4,78,40.4z M78,89.1\nc-9.1,0-16.5-7.4-16.5-16.5S68.9,56.2,78,56.2s16.5,7.4,16.5,16.5S87.1,89.1,78,89.1z\"/>\n</g>";
        return this.convertSvgToDataUri(locSvg);
    };
    WeatherElement.prototype.getWindSvg = function (stroke) {
        var windSvg = this.createIconSvg(stroke, '0 0 200 156', '13', '13');
        windSvg.innerHTML = "<g>\n<path class=\"st0\" d=\"M7.1,56.7h85.7c15.8,0,28.6-12.7,28.6-28.4S108.6,0,92.9,0C77.1,0,64.3,12.7,64.3,28.4h14.3\nc0-7.8,6.4-14.2,14.3-14.2c7.9,0,14.3,6.3,14.3,14.2c0,7.8-6.4,14.2-14.3,14.2H7.1c-3.9,0-7.1,3.2-7.1,7.1\"/>\n<path class=\"st0\" d=\"M164.3,99.3H7.1c-3.9,0-7.1,3.2-7.1,7.1c0,3.9,3.2,7.1,7.1,7.1h157.1c7.9,0,14.3,6.4,14.3,14.2\nc0,7.8-6.4,14.2-14.3,14.2c-7.9,0-14.3-6.3-14.3-14.2h-14.3c0,15.7,12.8,28.4,28.6,28.4c15.8,0,28.6-12.7,28.6-28.4\nS180.1,99.3,164.3,99.3L164.3,99.3z\"/>\n<path class=\"st0\" d=\"M7.1,85.1h157.1c19.7,0,35.7-15.9,35.7-35.5c0-19.6-16-35.5-35.7-35.5c-19.7,0-35.7,15.9-35.7,35.5\nc0,2.4,0.3,4.8,0.8,7.1h14.8c-0.8-2.2-1.3-4.6-1.3-7.1c0-11.7,9.6-21.3,21.4-21.3c11.8,0,21.4,9.5,21.4,21.3\nc0,11.1-8.6,20.2-19.6,21.1c-0.3,0-0.6,0.2-0.9,0.2H7.1C3.2,70.9,0,74.1,0,78C0,81.9,3.2,85.1,7.1,85.1L7.1,85.1z\"/>\n</g>";
        return this.convertSvgToDataUri(windSvg);
    };
    return WeatherElement;
}(NodeElement));
export { WeatherElement };
